export function removeHtmlFromString(stringWithHtml: string) {
  return stringWithHtml.replace(/<\/?[^>]+(>|$)/g, '')
}
